import { useEffect, useState } from "react";
import "./BarraProgreso.css";

const BarraProgreso = ({ porcentaje, width }) => {
  const [progreso, setProgreso] = useState(460);

  useEffect(() => {
    setProgreso(porcentaje * width);
  }, [porcentaje, width]);

  return (
    <div className="barra-progreso" style={{ width: width }}>
      <div style={{ width: `${progreso}px` }} className="progreso" />
    </div>
  );
};

export default BarraProgreso;
